import {Text, Icon, theme, styled} from "@reside/ui";

const SSOConfigurationBadge = styled.div`
  color: ${theme.color.gray100};
  background-color: ${theme.color.lightBlue10};
  width: fit-content;
  border: 1px solid ${theme.color.borderGray};
  border-radius: ${theme.space[1]}px;
  padding: ${theme.space[1]}px ${theme.space[2]}px;
  display: flex;
  align-items: center;
  gap: ${theme.space[1]}px;
  font-size: ${theme.fontSize[1]};
`;

export const SSOBadge = ({label}: {label: string}) => {
  return (
    <SSOConfigurationBadge>
      <Icon name="lock" size={12} />
      <Text as="span" fontSize={3}>
        {label}
      </Text>
    </SSOConfigurationBadge>
  );
};
